module.exports = __webpack_public_path__ + "img/showcase-5.962ff730.png";